import { useState, useEffect } from 'react';
import Select from '../audi-ui-components/Select';
import Dropdown from '../audi-ui-components/Dropdown';
import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';
import cn from 'classnames';
import API from '../functions/api';
import queryString from 'query-string';

const ModelModule = ({
  values, errors, touched, submitCount,
  setFieldValue, setFieldTouched = ()=>{}, onVariantChange,
  title, labelModel = "Model", labelVariant = "Variant",
  colClass = "col",
  form,
  includeOptionObjOnChange,
  additionalVariantFields = "",
  theme,
}) => {
  
  const [modelOpts, setModelOpts] = useState([]);
  const [variantOpts, setVariantOpts] = useState([]);
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const getModelOpts = (list = [], updatedValues) => {
    setIsLoading(true);
    const qString = queryString.parse(window?.location.search);
    const mList = qString.m ? qString.m.split(",").map(m => parseInt(m)) : [];
    const vList = qString.v ? qString.v.split(",").map(v => parseInt(v)) : [];
    // console.log(mList, vList);
    let gqlFilter = {status: {eq: true}};
    if (mList.length > 1) {
      gqlFilter.modelId = {in: mList};
    }
    if (form === "RaTD") {
      gqlFilter.showRaTD = {eq: true};
      gqlFilter.variants = {some: {and: {visibilityRaTD: {eq: true}, status: {eq: true}}}};
    }
    if (form === "startingPrice") {
      gqlFilter.variants = {some: {and: {startingPriceCalculator: {eq: true}, status: {eq: true}}}};
    }
    if (vList.length > 1) {
      if (!gqlFilter.variants) {
        gqlFilter.variants = {some: {and: {status: {eq: true}}}};
      }
      gqlFilter.variants.some.and.variantId = {in: vList};
    }
    API.post(`${process.env.RAZZLE_GQLAPI}`, {
      query: /* GraphQL */`query ($skip: Int, $take: Int, $sort: ModelDtoSortInput!, $filter: ModelDtoFilterInput) {
        modelList(skip: $skip, take: $take, order: [ $sort ], where: $filter) {
          items {
            value: modelId
            label: name
          }
          totalCount
        }
      }`,
      variables: {
        skip: list.length,
        take: 50,
        sort: {displayOrder: "ASC"},
        filter: gqlFilter
      }
    }).then((result) => {
      // console.log(result);
      if (result.data?.data?.modelList) {
        let newList = [...list, ...result.data.data.modelList.items];
        if (newList.length < result.data.data.modelList.totalCount) {
          // load more
          getModelOpts(newList);
        } else {
          setModelOpts(newList);
          if (updatedValues?.variantId) {
            getVariantOpts([], updatedValues, newList);
          } else if (updatedValues?.modelId && _findIndex(newList, {value: updatedValues?.modelId}) > -1) {
            if (includeOptionObjOnChange) {
              let opt = _find(newList, {value: updatedValues.modelId});
              setFieldValue("modelId", updatedValues.modelId, opt);
            } else {
              setFieldValue("modelId", updatedValues.modelId);
            }
            getVariantOpts([], updatedValues, newList);
          } else {
            setIsLoading(false);
          }
        }
      } else {
        setError("There was a problem getting the list of models");
        setIsLoading(false);
      }
    }).catch((err) => {
      setError("There was a problem getting the list of models");
      setIsLoading(false);
    });
  }

  const getModelId = (updatedValues) => {
    return new Promise((resolve, reject) => {
      let mId = updatedValues?.modelId || values?.modelId;
      if (!mId || mId === null) {
        let vId = updatedValues?.variantId || values?.variantId;
        if (!vId || vId === null) {
          reject();
        } else {
          API.post(`${process.env.RAZZLE_GQLAPI}`, {
            query: /* GraphQL */`query ($filter: VariantDtoFilterInput) {
              variantList(where: $filter) {
                items { modelId }
              }
            }`,
            variables: {
              filter: {variantId: {eq: parseInt(vId)}}
            }
          }).then((result) => {
            if (result.data?.data?.variantList) {
              let item = result.data.data.variantList.items[0];
              mId = item.modelId;
              if (mId) {
                resolve(mId);
              } else {
                reject();
              }
            } else {
              reject();
            }
          }).catch(() => {
            reject();
          });
        }
      } else {
        resolve(mId);
      }
    });
  }

  const getVariantOpts = async (list = [], updatedValues, modelOpts = []) => {
    setIsLoading(true);
    const qString = queryString.parse(window?.location.search);
    const vList = qString.v ? qString.v.split(",").map(v => parseInt(v)) : [];
    let mId = await getModelId(updatedValues);
    if (!mId || mId === null) {
      setError("There was a problem getting the list of variants");
      setIsLoading(false);
      return;
    }
    let gqlFilter = {status: {eq: true}, modelId: {eq: parseInt(mId)}};
    if (vList.length > 1) {
      gqlFilter.variantId = {in: vList};
    }
    if (form === "RaTD") { gqlFilter.visibilityRaTD = {eq: true}; };
    if (form === "startingPrice") { gqlFilter.startingPriceCalculator = {eq: true}; };
    API.post(`${process.env.RAZZLE_GQLAPI}`, {
      query: /* GraphQL */`query ($skip: Int, $take: Int, $sort: VariantDtoSortInput!, $filter: VariantDtoFilterInput) {
        variantList(skip: $skip, take: $take, order: [ $sort ], where: $filter) {
          items {
            value: variantId
            label: name
            modelId
            jellybeanImage
            ${additionalVariantFields}
          }
          totalCount
        }
      }`,
      variables: {
        skip: list.length,
        take: 50,
        sort: {name: "ASC"},
        filter: gqlFilter
      }
    }).then((result) => {
      // console.log(result);
      if (result.data?.data?.variantList) {
        let newList = [...list, ...result.data.data.variantList.items];
        if (newList.length < result.data.data.variantList.totalCount) {
          // load more
          getVariantOpts(newList, updatedValues, modelOpts);
        } else {
          let opts = newList.map(item => {
            return {
              ...item,
              jsxLabel: (<span className="model-module__opt">{item.jellybeanImage && <img src={item.jellybeanImage} alt="" />} <span>{item.label}</span></span>)
            };
          });
          setVariantOpts(opts);
          let vId = opts.length === 1 ? opts[0].value : updatedValues?.variantId;
          if (vId) {
            let opt = _find(opts, {value: vId});
            if (opt?.value) {
              if (includeOptionObjOnChange) {
                setFieldValue("variantId", vId, opt);
                let mOpt = _find(modelOpts, {value: opt.modelId});
                setFieldValue("modelId", opt.modelId, mOpt);
              } else {
                setFieldValue("variantId", vId);
                setFieldValue("modelId", opt.modelId);
              }
              if (typeof onVariantChange === "function") {
                onVariantChange(opt);
              }
            }
          } else {
            setFieldValue("variantId", null);
            if (typeof onVariantChange === "function") {
              onVariantChange(null);
            }
          }
        }
      } else {
        console.log("could not get variants");
        setError("There was a problem getting the list of variants");
      }
      setIsLoading(false);
    }).catch((err) => {
      console.log("variants error", err);
      setError("There was a problem getting the list of variants");
      setIsLoading(false);
    });
  }

  useEffect(() => {
    const qString = queryString.parse(window?.location.search);
    let vals = {};
    if (qString.m || qString.v) {
      let mList = qString.m ? qString.m.split(",") : [];
      if (mList.length === 1) { vals.modelId = parseInt(qString.m); }
      let vList = qString.v ? qString.v.split(",") : [];
      if (vList.length === 1) { vals.variantId = parseInt(qString.v); }
    }
    getModelOpts([], vals);
  }, []);

  return (
    <div className="model-module form-module">
      {title && <p className="aui-headline-5 mb-2"><b>{title}</b></p>}
      <div className="row">
        <div className={colClass}>
          <Select name="modelId"
            label={labelModel}
            options={modelOpts}
            value={values.modelId || ""}
            onChange={(v) => {
              if (includeOptionObjOnChange) {
                let opt = _find(modelOpts, {value: v});
                setFieldValue("modelId", v, opt);
              } else {
                setFieldValue("modelId", v);
              }
              getVariantOpts([], {modelId: v}, modelOpts);
            }}
            onBlur={() => { setFieldTouched("modelId"); }}
            isInvalid={errors?.modelId && (touched?.modelId || submitCount > 0)}
            invalidMessage={errors?.modelId}
            theme={theme === "dark" ? "light" : null}
          />
        </div>
        <div className={cn(colClass, {"d-none": !values.modelId && submitCount === 0})}>
          <Dropdown name="variantId"
            label={labelVariant}
            options={variantOpts}
            value={values.variantId || ""}
            onChange={(v) => {
              let opt = _find(variantOpts, {value: v});
              if (includeOptionObjOnChange) {
                setFieldValue("variantId", v, opt);
              } else {
                setFieldValue("variantId", v);
              }
              if (typeof onVariantChange === "function") { onVariantChange(opt); }
            }}
            onBlur={() => { setFieldTouched("variantId"); }}
            isInvalid={errors?.variantId && (touched?.variantId || submitCount > 0)}
            invalidMessage={errors?.variantId}
            theme={theme === "dark" ? "black" : null}
          />
        </div>
      </div>
      {isLoading && <p className="aui-small">Loading models...</p>}
      {error && <p className="aui-color-text-red"><b>{error}</b></p>}
    </div>
  );
}

export default ModelModule;
